import React from "react";
import DefaultForm from "../../../../../ui/forms/default-form";
import { hasAvailableAction } from "../../../../../ui/gov-actions";
import CwaFields from "../create-enrolment/cwa-fields";
import PeaFields from "../create-enrolment/pea-fields";
import { updateSubmitValues } from "../create-enrolment/enrolment-booking-schedule";
export { groupBookingsByDay } from "./helpers";

const available = record => hasAvailableAction(record, "edit_ccs_schedule");

const apiEndPoint = (regHolderId, regHolderType, childId) =>
  `/api/${regHolderType}/${regHolderId}/children/${childId}`;

const defaultValues = arrangement_type => ({
  arrangement_type: arrangement_type,
  enrolment_params: {}
});

const FormComponent = props => {
  const {
    addKey,
    errorAtKey,
    removeKey,
    values,
    errors,
    onChange,
    baseEndpoint
  } = props;
  return (
    <fieldset>
      {values.arrangement_type === "CWA" && (
        <CwaFields
          values={values}
          errors={errors}
          onChange={onChange}
          baseEndpoint={baseEndpoint}
          addKey={addKey}
          removeKey={removeKey}
        />
      )}

      {values.arrangement_type === "PEA" && (
        <PeaFields
          values={values}
          errors={errors}
          onChange={onChange}
          addKey={addKey}
          errorAtKey={errorAtKey}
          removeKey={removeKey}
          baseEndpoint={baseEndpoint}
        />
      )}
    </fieldset>
  );
};

const hasEnrolmentSchedule = ({ arrangement_type }) =>
  arrangement_type === "PEA" || arrangement_type === "CWA";

const calculateSubmitValues = values => hasEnrolmentSchedule(values) ? updateSubmitValues(values) : values;

const formValue = "arrangement_type";

const actionForm = ({ baseEndpoint, record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={process.env.REACT_APP_API_HOST + baseEndpoint + "/ccs-enrolments"}
    name={formValue}
    label="Create"
    calculateSubmitValues={calculateSubmitValues}
    handleSuccess={() =>
      handleSuccess(
        { [formValue]: "A new Parent Approval has been created" },
        formValue
      )
    }
    formOptions={{ defaultValues: defaultValues(record.type) }}
    formComponent={props => (
      <FormComponent {...props} baseEndpoint={baseEndpoint} />
    )}
  />
);

export const updateEnrolmentSchedule = ({
  regHolderId,
  regHolderType,
  child,
  refresh_enrolments,
  record
}) =>
  available(record)
    ? {
      label: "Update Enrolment Schedule",
      value: "arrangement_type",
      actionForm: actionForm({
        record: record,
        baseEndpoint: apiEndPoint(regHolderId, regHolderType, child.id)
      }),
      onComplete: refresh_enrolments
    }
    : null;



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/index.js